<template>
	<AppDialog ref="dialog_container" dialogName="NewOutputBlockDialog">
		<div class="new-output-block-dialog">
			<div class="dialog-title">Output fields</div>
			<div class="dialog-description">Edit fields that will return to the parent feature. Affects all end run actions</div>
			<div class="dialog-body">
				<FieldsDefinitionBuilder
					class="mt-4"
					fieldTitleText="Output field name"
					buttonText="+ Add output fields"
					fieldTypeText="output"
					:fieldsDefinitions="fieldsDefinitionsLocal"
					:isShowErrors="isShowErrors"
					:subflowsUsageWorkflowIds="selectedSubflow.sub_flow_parent_workflows"
					@onFieldsDefChanged="onFieldsDefChanged"
				/>
			</div>
			<div class="dialog-bottom flex-centerize">
				<SecondaryButton large @click="save"> Save </SecondaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { deleteNode } from '@/store/modules/selectedWorkflow/actions';

import FieldDefinitionService from '@/components/BlockEditor/editors/helpers/FieldsDefinitionBuilder/field-definition-service';

import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import FieldsDefinitionBuilder from '@/components/BlockEditor/editors/helpers/FieldsDefinitionBuilder/FieldsDefinitionBuilder.vue';

export default {
	name: 'NewOutputBlockDialog',
	components: {
		AppDialog,
		FieldsDefinitionBuilder,
	},
	props: {
		onSave: { type: Function },
		fieldsDefinitions: { type: Array },
		selectedSubflow: { type: Object },
	},
	data() {
		return { fieldsDefinitionsLocal: JSON.parse(JSON.stringify(this.fieldsDefinitions)), loading: false, isShowErrors: false };
	},
	computed: {
		isFieldDefinitionValid() {
			return this.fieldsDefinitionsLocal.reduce((res, fd) => res && FieldDefinitionService.isFieldDefinitionValid(fd), true);
		},
	},
	methods: {
		...mapActionsShorthand({ deleteNode }),
		close() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		cancel() {
			this.close();
		},
		async save() {
			if (this.isFieldDefinitionValid) {
				this.loading = true;
				try {
					this.onSave(this.fieldsDefinitionsLocal);
					const ret = {}; //await this.deleteNode({ id: this.block.id });
					if (ret?.error) {
						this.$toast.error(`Failed to delete step, please try again`);
					} else {
						this.close();
					}
				} finally {
					this.loading = false;
				}
			} else {
				this.isShowErrors = true;
			}
		},
		onFieldsDefChanged(newDefinitions) {
			this.fieldsDefinitionsLocal = newDefinitions;
		},
	},
};
</script>

<style scoped lang="scss">
.new-output-block-dialog {
	border-radius: 15px !important;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}

	.dialog-body {
		max-height: 400px;
		overflow: auto;
	}
}
</style>
